export enum ResponseStatusCodeToken {
    UNVERIFIED_TOKEN = 0,
    TOKEN_EXPIRED = 1,
    MISSING_AUTHORIZATION_HEADER = 2,
    UNAUTHORIZED = 3,
}
